<template>
  <a-popover placement="rightTop" overlay-class-name="show-popover" trigger="click">
    <template slot="content">
      <div class="popover-title">
        <img src="@/assets/img/icon_noice_file.png" alt="">
        轨迹预警信息
      </div>
      <div class="abnormal-item">
        <div class="abnormal-item-car">
          <a
            v-for="(item, index) in carList"
            :key="index"
            :class="['carBtn', carActIndex === index ? 'active' : '']"
            @click="carActIndex = index"
            >{{ item }}
          </a>
        </div>
        <a-timeline>
          <a-timeline-item
            v-for="item in list[carActIndex]"
            :key="item.wayBillCode"
            color="#606266"
          >
            <div class="title">{{item.ruleName}}</div>
            <div>{{item.starTime}}</div>
          </a-timeline-item>
        </a-timeline>
      </div>
    </template>
    <a
      class="look-more"
      @click="getMore"
    >
      明细
    </a>
  </a-popover>
</template>

<script>
import { getAlarmByUOrder } from '../api'
import env from '../../../../../env'

export default {
  name: 'ShowMore',
  props: {
    orderNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      carList: [],
      carActIndex: 0
    }
  },
  methods: {
    async getMore() {
      const res = await getAlarmByUOrder({
        filter: {
          uOrderCode: this.orderNo,
          ruleIds: env.ruleIds,
        },
        paging: false,
      })
      const carList = [];
      const list = []
      res.records.forEach(item => {
        if (item.licensePlate) {
          const index = carList.indexOf(item.licensePlate)
          if (index > -1) {
            list[index].push(item)
          } else {
            carList.push(item.licensePlate)
            list[list.length] = [item]
          }
        }
      });
      this.carList = carList
      this.list = list
    }
  }
}
</script>
<style lang="less" scoped>
.popover-title {
  font-size: 16px;
  font-weight: 500;
  color: #171717;
  border-bottom: 1px solid#f0f0f0;
  padding: 19px 24px;
  img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}
.abnormal-item {
  padding: 20px 24px;
  max-height: 504px;
  overflow-y: auto;
  .abnormal-item-car {
    display: flex;
  }
  .carBtn{
    border: none;
    background-size: 100% 100%;
    display: inline-block;
    width: 108px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #606266;
    margin-right: 16px;
    margin-bottom: 32px;
    background-image: url('../../../../assets/img/offcar_icon.png');
    &.active {
      color: #fff;
      background-image: url('../../../../assets/img/oncar_icon.png');
    }
  }
  .title {
    color: #171717;
    font-size: 17px;
  } 
}
</style>
<style lang="less">
.show-popover {
  .ant-popover-inner-content {
    padding: 0;
    width: 570px;
    .ant-timeline-item {
      .ant-timeline-item-head  {
        width: 8px;
        height: 8px;
        background: #606266;
        left: 1px;
      }
    }
  }
}
</style>